import { ReportModules, Signatory } from '@interfaces/report-templates.interface';

export const prepareSignatoriesData = (data: Signatory, module: ReportModules, studyId: string): Signatory => {
    return {
        firstName: data?.firstName?.trim(),
        lastName: data?.lastName?.trim(),
        jobTitle: data?.jobTitle?.trim(),
        studyId,
        module,
        ...(data?.id ? { id: data.id } : {}),
    };
};
